import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Product } from "../../types/types";
const products = localStorage.getItem('favorite')
const initialState: Product[] = []

const favorite = createSlice({
    name: 'favorite',
    initialState,
    reducers: {
        addFavoriteItem: (state, action: PayloadAction<Product>) => {
            if(state.find(item => item.id === action.payload.id)) return [...state]
            return [...state, action.payload]
        },
        removeFavoriteItem: (state, action: PayloadAction<number>) => state.filter(item => item.id !== action.payload)
    }
})

export const favoriteReducer = favorite.reducer
export const {addFavoriteItem, removeFavoriteItem} = favorite.actions